<div class="csv-dialog-container">
  <h2 mat-dialog-title>Add Facilities from CSV</h2>

  <mat-dialog-content>
    <div class="input-section">
      <p>Paste a comma-separated list of facility IDs:</p>
      <mat-form-field appearance="outline" class="full-width">
        <textarea matInput [formControl]="csvInput" placeholder="e.g., facility1, facility2, facility3" rows="4">
        </textarea>
      </mat-form-field>

      <div class="button-row">
        <button
          mat-raised-button
          color="primary"
          (click)="onAddClick()"
          [disabled]="!csvInput.value?.trim() || isLoading">
          <mat-icon>search</mat-icon>
          {{ isLoading ? 'Verifying...' : 'Verify IDs' }}
        </button>

        <button mat-button (click)="onClearClick()" [disabled]="!csvInput.value?.trim()">Clear</button>
      </div>
    </div>

    <!-- Loading indicator -->
    @if (isLoading) {
      <div class="loading-section">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Verifying facility IDs...</p>
      </div>
    }

    <!-- Results section -->
    @if (hasResults && !isLoading) {
      <div class="results-section">
        <!-- Found facilities table -->
        @if (foundFacilities.length > 0) {
          <div class="facilities-found">
            <h3>Facilities Found ({{ foundFacilities.length }})</h3>
            <table mat-table [dataSource]="foundFacilities" class="facilities-table">
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>ID</th>
                <td mat-cell *matCellDef="let facility">{{ facility.id }}</td>
              </ng-container>

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let facility">{{ facility.name }}</td>
              </ng-container>

              <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef>Address</th>
                <td mat-cell *matCellDef="let facility">{{ facility.address1 || 'N/A' }}</td>
              </ng-container>

              <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef>City</th>
                <td mat-cell *matCellDef="let facility">{{ facility.city || 'N/A' }}</td>
              </ng-container>

              <ng-container matColumnDef="state">
                <th mat-header-cell *matHeaderCellDef>State</th>
                <td mat-cell *matCellDef="let facility">{{ facility.state || 'N/A' }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['id', 'name', 'address', 'city', 'state']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['id', 'name', 'address', 'city', 'state']"></tr>
            </table>
          </div>
        }
        <!-- Not found IDs -->
        @if (notFoundIds.length > 0) {
          <div class="facilities-not-found">
            <h3>Facility IDs Not Found ({{ notFoundIds.length }})</h3>
            <div class="not-found-ids">
              @for (id of notFoundIds; track id) {
                <span class="not-found-id">{{ id }}</span>
              }
            </div>
          </div>
        }
        <!-- No results message -->
        @if (foundFacilities.length === 0 && notFoundIds.length === 0) {
          <div class="no-results">
            <p>No facility IDs were provided or all IDs were invalid.</p>
          </div>
        }
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancelClick()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onConfirmClick()" [disabled]="foundFacilities.length === 0">
      Add {{ foundFacilities.length }} Facilities
    </button>
  </mat-dialog-actions>
</div>
